import { BrowserRouter, Route, Switch } from 'react-router-dom';

import HomePage from './routes/home';
import InkPage from './routes/ink';
import NodesPage from './routes/nodes';
import { getHomeRoute, getNodesRoute } from './routes/routes';

export default function App() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path={getHomeRoute()} component={HomePage} exact />
                <Route path={getNodesRoute()} component={NodesPage} exact />
                <Route path={'/ink'} component={InkPage} exact />
                <Route component={HomePage} />
            </Switch>
        </BrowserRouter>
    )
}
